import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { ROUTES } from '@/constants/routes';

interface Props {
  roles: string[];
}

/**
 * Route-level role guard. Renders child routes only if the current user's role
 * is in the allowed list. On denial, redirects to /dashboard.
 */
export default function RoleRouteGuard({ roles }: Props) {
  const role = useAuthStore((s) => s.role);
  if (!role || !roles.includes(role)) return <Navigate to={ROUTES.DASHBOARD} replace />;
  return <Outlet />;
}
